import { unirest } from '../../../httpsnippet-lite/targets/java/unirest/client.js';
import { convertWithHttpSnippetLite } from '../../../utils/convertWithHttpSnippetLite.js';
/**
 * java/unirest
 */
export const javaUnirest = {
    target: 'java',
    client: 'unirest',
    title: 'Unirest',
    generate(request) {
        // TODO: Write an own converter
        return convertWithHttpSnippetLite(unirest, request);
    },
};
